import React from 'react';
import { Chip } from '@material-ui/core';
import { nivelDeFactor, estiloRiesgo } from '../helpers/factorRiesgoUtils';

/**
 * Etiqueta del nivel de riesgo de una solicitud (ALTO / MEDIO / BAJO).
 *
 * Acompaña al avatar coloreado con el mismo nivel: el color se ve de lejos y la
 * palabra elimina la duda de qué significa ese color.
 *
 * En el listado va después del nombre del factor y no en la línea del nombre del
 * estudiante, porque ListarDatos usa `fila_principal` tal cual para el buscador:
 * si esa función devuelve JSX, la búsqueda por nombre deja de encontrar.
 *
 * No pinta nada cuando la solicitud no tiene factor — las creadas antes de esta
 * funcionalidad — para no ensuciar la lista con una etiqueta vacía.
 */
export default function ChipFactorRiesgo({ factor, size = 'small', posicion = 'izquierda' }) {
    const estilo = estiloRiesgo(nivelDeFactor(factor));
    if (!estilo) return null;

    return (
        <Chip
            size={size}
            label={estilo.etiqueta}
            title={factor?.nombre || ''}
            style={{
                backgroundColor: estilo.backgroundColor,
                color: estilo.color,
                fontWeight: 700,
                fontSize: 10.5,
                letterSpacing: '.06em',
                height: 18,
                ...(posicion === 'derecha' ? { marginLeft: 8 } : { marginRight: 8 }),
            }}
        />
    );
}
